<div #map class="map" [class]="customClass" [ngClass]="{ hidden: hidden }"></div>
